<ul>
  <div *ngFor="let item of items">
    <ng-content></ng-content>
  </div>
</ul>
